// Lote V-8 — Schemas para o feed de notificacións do user.
import { z } from 'zod';
export const NotificationListQuerySchema = z.object({
    limit: z.coerce.number().int().positive().max(50).default(30),
});
export const NotificationItemSchema = z.object({
    id: z.string().uuid(),
    type: z.string(),
    title: z.string(),
    text: z.string(),
    data_json: z.unknown().optional(),
    read_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }),
});
export const NotificationListResponseSchema = z.object({
    notifications: z.array(NotificationItemSchema),
    unread_count: z.number().int().nonnegative(),
});
export const NotificationUnreadCountResponseSchema = z.object({
    unread_count: z.number().int().nonnegative(),
});
export const NotificationMarkReadResponseSchema = z.object({
    id: z.string().uuid(),
    read_at: z.string().datetime({ offset: true }),
});
export const NotificationMarkAllReadResponseSchema = z.object({
    marked_read: z.number().int().nonnegative(),
});
//# sourceMappingURL=notification.js.map